export enum ExecutionMode {
  ASYNC = "async",
  SYNC = "sync",
}
